import { createAction, createStandardAction } from 'typesafe-actions';

import { OfferDetailsDTO } from '../../types/dto/OfferDetailsDTO';
import { OfferShortDTO } from '../../types/dto/OfferShortDTO';
import { VoucherDTO } from '../../types/dto/VoucherDTO';
import { OfferErrorInfo } from './Types';

export const allOffersRequest = createAction('@@app/ALL_OFFERS_REQUEST');
export const allOffersSuccess = createStandardAction('@@app/ALL_OFFERS_SUCCESS')<OfferShortDTO[]>();
export const allOffersFailure = createAction('@@app/ALL_OFFERS_FAILURE');

export const getOfferRequest = createAction('@@app/GET_OFFER_REQUEST');
export const getOfferSuccess = createStandardAction('@@app/GET_OFFER_SUCCESS')<OfferDetailsDTO>();
export const getOfferFailure = createStandardAction('@@app/GET_OFFER_FAILURE')<OfferErrorInfo>();

export const requestVoucherRequest = createAction('@@app/REQUEST_VOUCHER_REQUEST');
export const requestVoucherSuccess = createAction('@@app/REQUEST_VOUCHER_SUCCESS');
export const requestVoucherFailure = createStandardAction('@@app/REQUEST_VOUCHER_FAILURE')<OfferErrorInfo>();

export const getVoucherRequest = createAction('@@app/GET_VOUCHER_REQUEST');
export const getVoucherSuccess = createStandardAction('@@app/GET_VOUCHER_SUCCESS')<VoucherDTO>();
export const getVoucherFailure = createAction('@@app/GET_VOUCHER_FAILURE');

export const printVoucherRequest = createAction('@@app/PRINT_VOUCHER_REQUEST');
export const printVoucherSuccess = createStandardAction('@@app/PRINT_VOUCHER_SUCCESS')<Blob>();
export const printVoucherFailure = createStandardAction('@@app/PRINT_VOUCHER_FAILURE')<OfferErrorInfo>();
